import React from "react";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";


const TermsAndConditions = () => {
  return (
    <div className="page-container" id="missionidd">
      {/* Breadcrumbs Header */}
        <BreadcrumbsHeader 
          title="TERMS & CONDITION" 
          backgroundImage="/images/header/about-isols.jpg" 
        />

      {/* Terms & Conditions Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 wow slideInLeft">
              <div className="b-services-item">
                <div className="services-text">
                  <h2 className="termm">Understanding Our Terms and Conditions</h2>
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    OVERVIEW
                  </h6>
                  <p>
                    This website is operated by ISOLS Group Private Limited. Throughout the
                    site, the terms “we”, “us” and “our” refer to ISOLS Group Private Limited.
                    ISOLS Group Private Limited offers this website, including all information,
                    services, solutions & products available from this site to you, the user,
                    conditioned upon your acceptance of all terms, conditions, policies and
                    notices stated here.
                  </p>
                  <p>
                    By visiting our site, you engage in our “Service” and agree to be bound by
                    the following terms and conditions (“Terms of Service”, “Terms”), including
                    those additional terms and conditions and policies referenced herein and/or
                    available by hyperlink. These Terms of Service apply to all users of the site,
                    including without limitation users who are browsers, vendors, customers, merchants,
                    and/or contributors of content.
                  </p>
                  <p>
                    Please read these Terms of Service carefully before accessing or using our
                    website or Android or iOS mobile application. By accessing or using any part
                    of the site, you agree to be bound by these Terms of Service. If you do not
                    agree to all the terms and conditions of this agreement, then you should not
                    proceed forward to access our website or Android or iOS mobile application
                    or use any services.
                  </p>
                </div>

                {/* Sections */}
                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 1 - GENERAL CONDITIONS
                  </h6>
                  <p>
                    We reserve the right to refuse service to anyone for any reason at any time.
                    You understand that your content (not including credit card information),
                    may be transferred unencrypted and involve (a) transmissions over various
                    networks; and (b) changes to conform and adapt to technical requirements
                    of connecting networks or devices. Credit card information is always encrypted
                    during transfer over networks, and is the responsibility of respective payment
                    gateway company that is integrated.
                  </p>
                  <p>
                    You agree not to reproduce, duplicate, copy, sell, resell or exploit any
                    portion of the Services, Solutions or Product, use of the Service, or access
                    to the Service or any contact on our website or Android or iOS mobile
                    application through which the services are provided, without getting written
                    permission by us. The headings used in this agreement are included for convenience
                    only and will not limit or otherwise affect these Terms.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 2 - ACCURACY, COMPLETENESS AND TIMELINESS OF WEBSITE CONTENT
                  </h6>
                  <p>
                    We are not responsible if information made available on this website is
                    not accurate, complete or current from user perspective. The content on
                    this site is provided for giving the general overview only about the
                    services, solutions & products that are being offered and should not
                    be relied upon or used as the sole basis for making decisions without
                    consulting primary, more accurate, more complete or more timely sources
                    or ISOLS expert advisors. We reserve the right to modify the contents
                    of this site at any time, but we have no obligation to update any information
                    on our site. You agree that it is your responsibility to monitor changes
                    to our site.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 3 - OPTIONAL PLUGINS OR TOOLS
                  </h6>
                  <p>
                    We may provide you with access to third-party plugins/tools over which
                    we neither monitor nor have any control nor input. You acknowledge and
                    agree that we provide access to such tools ”as is” and “as available”
                    without any warranties, representations or conditions of any kind and
                    without any endorsement. We shall have no liability whatsoever arising
                    from or relating to your use of optional third-party tools such as live
                    chat, WhatsApp plugin, etc.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 4 - THIRD-PARTY LINKS
                  </h6>
                  <p>
                    Certain content, services available via our Service may include materials
                    from third-parties. Third-party links on this site may direct you to
                    third-party websites that are not affiliated with us. We are not responsible
                    for examining or evaluating the content or accuracy and we do not warrant
                    and will not have any liability or responsibility for any third-party materials
                    or websites.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 5 - USER INPUTS, FEEDBACK AND OTHER SUBMISSIONS
                  </h6>
                  <p>
                    If, at our request, you send certain specific submissions (for example blog guest posts)
                    or without a request from us you send us ideas, suggestions or other materials,
                    you agree that we may, at any time, without restriction, edit, copy, publish,
                    distribute, translate and otherwise use in any medium any inputs that you forward
                    to us.
                  </p>
                  <p>1- to maintain any inputs in confidence;</p>
                  <p>2- to pay compensation for any inputs;</p>
                  <p>3- to respond to any inputs. We may, but have no obligation to, monitor, edit or remove content...</p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 6 - PERSONAL INFORMATION
                  </h6>
                  <p>
                    Your submission of personal information through the website enquiry form or
                    while purchasing a product from ISOLS shop is governed by our Privacy Policy.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 7 - GOVERNING LAW
                  </h6>
                  <p>
                    These Terms of Service and any separate agreements whereby we provide you
                    Services shall be governed by and construed in accordance with the laws
                    of India and jurisdiction of New Delhi.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 8 - CHANGES TO TERMS OF SERVICE
                  </h6>
                  <p>
                    You can review the most current version of the Terms of Service at any time
                    at this page. We reserve the right, at our sole discretion, to update, change
                    or replace any part of these Terms of Service by posting updates and changes
                    to our website or Android or iOS mobile application.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 9 - CONTACT INFORMATION
                  </h6>
                  <p>Questions about the Terms of Service should be sent to us at</p>
                </div>

                <div className="services-text">
                  <p>
                    <b>Last Updated on: 10th July, 2021</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsAndConditions;
